import React, { useEffect, useRef, useState } from 'react'
import './Toast.scss'
import { SUCCESS } from 'configs/constants'

interface Props {
  type?: 'success' | 'error'
  message?: { title?: string; content?: string }
  duration?: number
  onClick?: (e: any) => void
  onClose?: any
}

const isAdmin = () => window.location.pathname.includes('/admin')

const Toast: React.FC<Props> = (props) => {
  const { type = SUCCESS, message, duration = 5000, onClose } = props
  const [state, setState] = useState<'' | 'slide-in' | 'fade-out'>('')
  const timeout = useRef<any>()
  const ref = useRef<any>()
  const { title = 'Thông tin', content = 'Đây là bánh mì nướng!' } = message || {}

  /**
   * Close the toast
   * @param {*} e click event
   */
  const close = (e?: any) => {
    // Prevent click parent when click close
    e?.stopPropagation()

    setState('')
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      setState('fade-out')

      timeout.current = setTimeout(() => {
        onClose?.()
      }, 400)
    }, 400)
  }

  useEffect(() => {
    setTimeout(() => setState('slide-in'), 10)
    if (duration) {
      timeout.current = setTimeout(() => {
        close()
      }, duration)
    }
    return () => clearTimeout(timeout.current)
  }, [])

  const isFadeOut = state === 'fade-out'

  return (
    <div
      className={`toast ${state} ${type}`}
      ref={ref}
      style={{
        maxHeight: isFadeOut ? 0 : ref.current?.scrollHeight,
        marginBottom: isFadeOut ? 0 : 8,
        padding: isFadeOut ? 0 : isAdmin() ? 16 : '20px 24px',
      }}
    >
      <i className={`icon-${type === SUCCESS ? 'checkmark' : 'close'}-circle`} />
      <div>
        <p className="toast-title typo-20-6">{title}</p>
        <p className="label toast-content typo-16-5">{content}</p>
      </div>
    </div>
  )
}

export default Toast
